import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const Home = () => {
  const [stats, setStats] = useState({
    buildings: 0,
    activeKeys: 0,
    reports: 0,
    teamMembers: 0,
  });
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user?.access_level === 1;

  useEffect(() => {
    const fetchStats = async () => {
      const headers = {
        "api-key": process.env.REACT_APP_API_KEY,
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const requests = [
        axios.get(`${process.env.REACT_APP_API_URL}building/list`, { headers }),
        isAdmin
          ? axios.get(`${process.env.REACT_APP_API_URL}key/list`, { headers })
          : Promise.resolve(null),
        axios.get(`${process.env.REACT_APP_API_URL}reports/keys`, { headers }),
        isAdmin
          ? axios.get(`${process.env.REACT_APP_API_URL}auth/list_users`, { headers })
          : Promise.resolve(null),
      ];

      const [buildingsRes, keysRes, reportsRes, teamRes] = await Promise.allSettled(requests);

      setStats({
        buildings:
          buildingsRes.status === "fulfilled"
            ? buildingsRes.value?.data?.data?.pagination?.total || 0
            : 0,
        activeKeys:
          keysRes.status === "fulfilled" && keysRes.value
            ? keysRes.value?.data?.data?.pagination?.total || 0
            : 0,
        reports:
          reportsRes.status === "fulfilled"
            ? (reportsRes.value?.data?.data || []).length
            : 0,
        teamMembers:
          teamRes.status === "fulfilled" && teamRes.value
            ? teamRes.value?.data?.data?.pagination?.total || 0
            : 0,
      });

      setLoading(false);
    };

    fetchStats();
  }, [isAdmin]);

  const formatStat = (num) => String(num).padStart(2, "0");

  const statCards = [
    {
      label: "Total Buildings",
      value: stats.buildings,
      icon: "icon-icon-20",
    },
    {
      label: "Active Keys",
      value: stats.activeKeys,
      icon: "icon-icon-21",
    },
    {
      label: "Reports Generated",
      value: stats.reports,
      icon: "icon-icon-24",
    },
    {
      label: "Team Members",
      value: stats.teamMembers,
      icon: "icon-icon-19",
    },
  ];

  const quickActions = [
    {
      label: "Add Building",
      description: "Create a new property entry",
      icon: "icon-icon-20",
      link: "/buildings/create-building",
    },
    ...(isAdmin
      ? [
          {
            label: "Create Key",
            description: "Define calculation parameters",
            icon: "icon-icon-21",
            link: "/create-key",
          },
        ]
      : []),
    {
      label: "Import Data",
      description: "Upload Excel/CSV files",
      icon: "icon-icon-22",
      link: "/import-data",
    },
  ];

  return (
    <div className="admin-page dashboard-page">
      <div className="dashboard-header">
        <h1 className="page-section-title">Dashboard</h1>
        <p className="dashboard-subtitle">
          Welcome back, {user?.name || "Admin User"}. Here's what's happening with your properties today.
        </p>
      </div>

      <div className="row g-4 mb-5">
        {statCards.map((card, index) => (
          <div key={index} className="col-12 col-sm-6 col-xl-3">
            <div className="stat-card">
              <div className="stat-card-body">
                <p className="stat-label">{card.label}</p>
                <h2 className="stat-value">
                  {loading ? "--" : formatStat(card.value)}
                </h2>
              </div>
              <div className="stat-icon-circle">
                <i className={card.icon}></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="quick-actions-section">
        <h2 className="quick-actions-title">Quick Actions</h2>
        <div className="row g-4">
          {quickActions.map((action, index) => (
            <div key={index} className="col-12 col-md-4">
              <Link to={action.link} className="quick-action-card">
                <div className="quick-action-icon">
                  <i className={action.icon}></i>
                </div>
                <h3 className="quick-action-label">{action.label}</h3>
                <p className="quick-action-desc">{action.description}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
